import { axiosWrapper } from "../../axiosWrapper";

export class CustomerAccountService {

    public static async getRecentlyViewedData() {
        return await axiosWrapper.Get("Accounts/RecentlyViewedData");
    }

    public static async getCustomerAccountsInfo() {
        return await axiosWrapper.Get("Accounts/CustomerAccounts");
    }
}